import axios from './_axios_config';
import { request, buildQuery } from './_process_request';

export const ct_contacts = {
    async getContacts(params) {
        return request(axios.get(`/contacts${buildQuery(params)}`));
    },

    async getContact(id) {
        return request(axios.get(`/contacts/${id}`));
    },

    async createContact(data) {
        return request(axios.post('/contacts', data));
    },

    async updateContact(id, data) {
        return request(axios.put(`/contacts/${id}`, data));
    },

    async deleteContact(id) {
        return request(axios.delete(`/contacts/${id}`));
    },
};
